// extracted by mini-css-extract-plugin
export default {"images":"BeforeAfter-module__images--7Zmqj"};